"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const date_fns_1 = require("date-fns");
const utils_1 = require("@loadsure/utils");
class Losses {
    constructor(data) {
        this.yearsOfClaimHistory = data.yearsOfClaimHistory;
        this.claimsHistory = data.claimsHistory;
        this.lossRecordAvailable = data.lossRecordAvailable;
        this.confirmNoKnowLossHistory = data.confirmNoKnowLossHistory;
        this.lossRecordDocuments = data.lossRecordDocuments;
        this.claimDescription = data.claimDescription;
    }
    static empty() {
        const data = {
            yearsOfClaimHistory: 5,
            claimsHistory: [],
            lossRecordAvailable: null,
            confirmNoKnowLossHistory: _1.emptyConfirmNoKnowLossHistory(),
            lossRecordDocuments: [],
            claimDescription: ""
        };
        const newLosses = new Losses(data);
        newLosses.claimsHistory = Losses.getClaimsHistoryStructure(data.yearsOfClaimHistory || 5);
        return newLosses;
    }
    static fromObj(data) {
        if (!data) {
            return Losses.empty();
        }
        const claimsHistory = data.claimsHistory
            ? _1.ClaimHistoryRecord.getRecords(data.claimsHistory)
            : [];
        return new Losses(Object.assign(Object.assign({}, data), { claimsHistory }));
    }
    static getClaimsHistoryStructure(years) {
        const claimsHistory = [];
        if (years > 0) {
            for (let i = 0; i < years; i += 1) {
                const year = date_fns_1.subYears(new Date(), i);
                const claimsHistoryToPush = new _1.ClaimHistoryRecord({
                    year: date_fns_1.getYear(year),
                    totalGrossLosses: null,
                    numberOfLosses: null
                });
                claimsHistory.push(claimsHistoryToPush);
            }
        }
        return claimsHistory;
    }
    validateClaimsHistory(errors) {
        const { yearsOfClaimHistory, claimsHistory } = this;
        if (!utils_1.isNumber(yearsOfClaimHistory))
            errors.push("Wrong year of claims history");
        if (utils_1.isNumber(yearsOfClaimHistory) &&
            yearsOfClaimHistory !== undefined &&
            yearsOfClaimHistory >= 1) {
            if (!Array.isArray(claimsHistory) ||
                claimsHistory.length < yearsOfClaimHistory)
                errors.push("Wrong length of claims history");
            else if (!claimsHistory.every((claimHistoryRecord) => claimHistoryRecord instanceof _1.ClaimHistoryRecord &&
                claimHistoryRecord.isValid()))
                errors.push("Wrong structure of claims history");
        }
        return errors;
    }
    validate() {
        let errors = [];
        const { lossRecordAvailable, lossRecordDocuments, confirmNoKnowLossHistory } = this;
        errors = this.validateClaimsHistory(errors);
        if (typeof lossRecordAvailable !== "boolean")
            errors.push("Wrong flag loss record history available");
        if (lossRecordAvailable &&
            (!Array.isArray(lossRecordDocuments) ||
                !lossRecordDocuments.length ||
                !lossRecordDocuments.every(({ documentPath }) => documentPath)))
            errors.push("Wrong loss record documents");
        if (!(confirmNoKnowLossHistory === null || confirmNoKnowLossHistory === void 0 ? void 0 : confirmNoKnowLossHistory.confirmed) ||
            !(confirmNoKnowLossHistory === null || confirmNoKnowLossHistory === void 0 ? void 0 : confirmNoKnowLossHistory.confirmedBy))
            errors.push("Wrong certify information accurate");
        return errors;
    }
}
exports.default = Losses;
//# sourceMappingURL=losses.class.js.map